export default {
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    image: "/welcome/quiz_peru.png",
    imageMobile: "/welcome/quiz_peru_mobile.png",
    title: "Obtenga una invitación para una clase GRATIS en 1 minuto",
    subtitle: "Tu hijo/a podrá participar en la clase que prefiera",
    button: "Recibe clase gratis 🚀",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: [
          "🔥 ¡Si!", 
          "🤗 No. Lo hace solo para divertirse y eso está bien"
      ],
    },
    2: {
      question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
    3: {
      title: "¿A qué hora estarías disponible para una clase de prueba?",
      type: "timeslot",
      subtitle: "¡Sólo unos pasos más para reservar tu clase gratuita! Queremos conocerte 🥳",
      button: "Reserva gratis 🎁",
    },
    4: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      subtitle: "Elegiremos el curso más entretenido según la edad de tu hijo/a",
      button: "Continuar 🚀",
    },
    5: {
      question:
        "¿Cuáles son las habilidades de tu hijo con la computadora/portátil?",
      answers: [
          "👍 No tiene conocimientos, debe estudiar lo básico", 
          "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
          "🖥 Nivel intermedio, quiere profundizar conocimientos",
          "🕹 Usa los dispositivos más que nada para juegos",
      ],
    },
    6: {
      title: "¿Cómo se llama tu hijo/a?",
      type: "child_name",
      subtitle: "Los datos están protegidos y se eliminarán cuando lo solicites 🚨",
      button: "Continuar 🚀",
    },
    7: {
      title: "Introduce tu correo electrónico",
      type: "mail",
      subtitle: "Lo necesitamos para enviarte un enlace para conectarte a la clase gratuita",
      button: "Continuar 🚀",
    },
    8: {
      question:
        "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo?",
      answers: [
          "🤔 Habilidades blandas", 
          "🎓 Preparación para una carrera a futuro",
          "🖥 Actividades extracurriculares",
      ],
    },
    9: {
      title: "Introduce tu número de teléfono",
      type: "phone",
      subtitle: "Lo necesitamos para confirmar tu presencia a la clase gratuita 📞",
      button: "Casi terminamos 🔥",
    },
    10: {
      title: "Introduce tu nombre",
      type: "parent_name",
      subtitle: "Nuestro nombre es Kodland, ¿cuál es el tuyo?",
      button: "Reserva gratis 🎉",
    },
  },
};


